import {
  type Apartment,
  type ApartmentRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';

// Custom handler for apartment to include revenue rows
export const handleCustomApartmentNestedCase = createBaseRentHandler<
  Apartment,
  ApartmentRevenueRow
>('apartmentrevenuerow');
